import React from 'react';
import moment from 'moment';

import http from 'api/http';
import { boatAPI } from 'api/requests';

import ApplicationActions from 'Components/ApplicationActions';
import { MultiInput, Input } from 'Components/Input';
import Button, { buttonColor } from 'Components/Button';
import FilePicker from 'Components/FilePicker';
import DatePicker from 'Components/DatePicker';

export default class FloatationCapacity extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      testDate: props.boat.floatationCapacity.testDate ? props.boat.floatationCapacity.testDate : '',
      files: props.boat.floatationCapacity.files ? [...props.boat.floatationCapacity.files] : [],
      uploadAvailable: false
    };

    this.errors = {};
    this.filesIdsToDelete = [];
    this.inputErrors = {};

    this.currentDate = moment().utc().hour(23).minute(59).second(59).millisecond(999);
  }

  shouldComponentUpdate(nextProps) {
    if (nextProps.boat.floatationCapacity.files) {
      if (nextProps.boat.floatationCapacity.files.length > this.state.files.length + this.filesIdsToDelete.length) {
        this.setState({
          ...nextProps.boat.floatationCapacity,
          testDate: nextProps.boat.floatationCapacity.testDate ? nextProps.boat.floatationCapacity.testDate : '',
        });
      }
    }

    return true;
  }

  __isValidDate = () => {
    const { testDate } = this.state;

    return testDate.isValid && testDate.isValid();
  };

  handleDateChoose = (utcDate, error) => {
    const { files } = this.state;
    const { markStepAsRedacted, boat } = this.props;

    markStepAsRedacted();

    if (error) this.errors.testDate = 'Provide valid date, or completely delete it';

    if (!files.length && boat.isFloatationTestReportRequired) {
      this.errors.files = 'Test Report File should be uploaded';
    }

    if (utcDate && utcDate.isAfter(this.currentDate)) {
      this.errors.testDate = 'Cannot select Flotation Test Date in the future';
    } else if (!error) {
      delete this.errors.testDate;
    }

    this.setState({ testDate: utcDate });
  };

  handleInputChange = targetField => (value, error) => {
    const {mhaPersonsCapacity, mhaPersonsCapacityRefDepth} = this.state;

    const {markStepAsRedacted} = this.props;

    markStepAsRedacted();
    if (!value || error) {
      if (!this.inputErrors[targetField]) this.inputErrors[targetField] = true;
      this.setState({[targetField]: value});
    } else {
      if (this.inputErrors[targetField]) delete this.inputErrors[targetField];

      this.setState({[targetField]: value}, () => {
        var newVal = this.state[targetField];
        if (targetField === 'mhaPersonsCapacity') {
          if (newVal !== undefined) {
            if (newVal > 10)
              this.inputErrors.mhaPersonsCapacity = 'Max Heel Angle at Persons Capacity should be no greater than 10 degrees.';
            //else if (this.inputErrors.mhaPersonsCapacity = 'Max Heel Angle at Persons Capacity should be no greater than 10 degrees.') delete this.inputErrors.mhaPersonsCapacity;
          }
        } else if (targetField === 'mhaPersonsCapacityRefDepth') {
          if (newVal !== undefined) {
            if (newVal < -6)
              this.inputErrors.mhaPersonsCapacityRefDepth = 'Reference Depth should be taken from no greater than -6 inches.';
            //else if (this.inputErrors.mhaPersonsCapacityRefDepth = 'Reference Depth should be taken from no greater than -6 inches.') delete this.inputErrors.mhaPersonsCapacityRefDepth;
          }
        } else if (targetField === 'mhaStarboardStability') {
          if (newVal !== undefined) {
            if (newVal > 30)
              this.inputErrors.mhaStarboardStability = 'Max Heel Angle on Starboard Stability Test should be no greater than 30 degrees.';
          }
        } else if (targetField === 'mhaStarboardStabilityRefDepth') {
          if (newVal !== undefined) {
            if (newVal < -12)
              this.inputErrors.mhaStarboardStabilityRefDepth = 'Reference Depth should be taken from no greater than -12 inches.';
          }
        } else if (targetField === 'mhaPortStability') {
          if (newVal !== undefined) {
            if (newVal > 30)
              this.inputErrors.mhaPortStability = 'Max Heel Angle on Port Stability Test should be no greater than 30 degrees.';
          }
        } else if (targetField === 'mhaPortStabilityRefDepth') {
          if (newVal !== undefined) {
            if (newVal < -12)
              this.inputErrors.mhaPortStabilityRefDepth = 'Reference Depth should be taken from no greater than -12 inches.';
          }
        } else if (targetField === 'mhaWithoutPersons') {
          if (newVal !== undefined) {
            if (newVal > 10)
              this.inputErrors.mhaWithoutPersons = 'Max Heel Angle without Persons should be no greater than 10 degrees.';
          }
        } else if (targetField === 'mhaWithoutPersonsRefDepth') {
          if (newVal !== undefined) {
            if (newVal < -6)
              this.inputErrors.mhaWithoutPersonsRefDepth = 'Reference Depth should be taken from no greater than -6 inches.';
          }
        }
        if(this.state['mhaPersonsCapacity'] && !this.inputErrors.mhaPersonsCapacity && this.state['mhaPersonsCapacityRefDepth'] && !this.inputErrors.mhaPersonsCapacityRefDepth &&
          this.state['mhaStarboardStability'] && !this.inputErrors.mhaStarboardStability && this.state['mhaStarboardStabilityRefDepth'] && !this.inputErrors.mhaStarboardStabilityRefDepth &&
          this.state['mhaPortStability'] && !this.inputErrors.mhaPortStability && this.state['mhaPortStabilityRefDepth'] && !this.inputErrors.mhaPortStabilityRefDepth &&
          this.state['mhaWithoutPersons'] && !this.inputErrors.mhaWithoutPersons && this.state['mhaWithoutPersonsRefDepth'] && !this.inputErrors.mhaWithoutPersonsRefDepth) {
          this.setState({ uploadAvailable: true });
        } else {
          this.setState({ uploadAvailable: false });
        }

        this.forceUpdate();
      });
    }
  };

  handleFileSelect = files => {
    const { markStepAsRedacted } = this.props;

    markStepAsRedacted();

    if (!this.__isValidDate()) this.errors.testDate = true;
    delete this.errors.files;

    this.setState(prevState => ({
      files: [...prevState.files, ...files],
    }));
  };

  handleRemoveFile = index => () => {
    const { files } = this.state;
    const { markStepAsRedacted, boat } = this.props;

    markStepAsRedacted();

    if (files[index].created) {
      this.filesIdsToDelete.push(files[index].id);
    }

    if (!this.errors.testDate && files.length === 1 && boat.isFloatationTestReportRequired) {
      this.errors.files = 'Test Report File should be uploaded';
    }

    if (files.length === 1) {
      delete this.errors.testDate;
    }

    this.setState(prevState => ({ files: prevState.files.filter((_, prevIndex) => index !== prevIndex) }));
  };

  validateStep = () => {
    const { files } = this.state;
    const { boat } = this.props;

    if (boat.isFloatationTestReportRequired) {
      if (!files.length) this.errors.files = 'Test Report File should be uploaded';
      if (!this.__isValidDate()) this.errors.testDate = true;
    } else {
      if (this.__isValidDate() && !files.length) this.errors.files = 'Test Report File should be uploaded';
      if (files.length && !this.__isValidDate()) this.errors.testDate = true;
    }

    this.forceUpdate();
  };

  saveFloatationTestReports = () => {
    const { files, testDate } = this.state;
    const { boat } = this.props;

    return new Promise((resolve, reject) => {
      if (files.length || (boat.floatationCapacity.testDate && boat.floatationCapacity.testDate.isSame(testDate))) {
        const requestJSON = { testDate: testDate.utc() };
        const data = new FormData();
        data.append('json', JSON.stringify(requestJSON));
        files.filter(file => !file.created).forEach(file => data.append('reports', file));
        http
          .post(boatAPI.uploadFloatationTestReports(boat.id), data)
          .then(resolve)
          .catch(() => {
            this.setState({ testDate: boat.floatationCapacity.testDate, files: boat.floatationCapacity.files }, () => {
              reject();
            });
          });
      } else {
        resolve();
      }
    });
  };

  deleteFloatationTestReports = () => {
    const { files } = this.state;
    const { boat } = this.props;

    return new Promise((resolve, reject) => {
      if (this.filesIdsToDelete.length) {
        http
          .put(boatAPI.deleteFloatationTestReports(boat.id), this.filesIdsToDelete)
          .then(() => {
            this.filesIdsToDelete = [];
            this.setState({ files: files.filter(({ id }) => !this.filesIdsToDelete.includes(id)) });
            resolve();
          })
          .catch(() => {
            this.filesIdsToDelete = [];
            this.setState({ testDate: boat.floatationCapacity.testDate, files });
            reject();
          });
      } else {
        resolve();
      }
    });
  };

  saveData = () => {
    const { boat, updateBoatDetails } = this.props;
    const { testDate } = this.state;

    this.validateStep();
    return new Promise((resolve, reject) => {
      if (Object.keys(this.errors).length) {
        reject();
      } else {
        this.saveFloatationTestReports()
          .then(() => {
            return this.deleteFloatationTestReports();
          })
          .then(() => {
            http.get(boatAPI.getFloatationTestReports(boat.id)).then(({ data }) => {
              this.setState({ files: data });
              updateBoatDetails({ floatationCapacity: { testDate: testDate, files: data } });
            });
            resolve();
          })
          .catch(() => {
            reject();
          });
      }
    });
  };

  handleMoveToNextStep = () => {
    const { goToStep } = this.props;

    this.saveData().then(() => {
      goToStep('next', true);
    });
  };

  handleUploadReq = () => {
    this.setState({ showControlFields: true, showUploadButton: false });
  };

  handleMoveToArbitraryStep = stepId => {
    const { goToStep, stepIsChanged } = this.props;
    if (!stepIsChanged) {
      return goToStep(typeof stepId === 'string' ? stepId : 'prev', true);
    }

    this.saveData()
      .then(() => {
        goToStep(typeof stepId === 'string' ? stepId : 'prev', true);
      })
      .catch(() => {
        goToStep(typeof stepId === 'string' ? stepId : 'prev', false);
      });
  };

  render() {
    const { getNavBar, getHeader, stepIsChanged, boat } = this.props;
    const { testDate, files, showControlFields, showUploadButton, mhaPersonsCapacity, mhaPersonsCapacityRefDepth,
      mhaStarboardStability, mhaStarboardStabilityRefDepth, mhaPortStability, mhaPortStabilityRefDepth,
      mhaWithoutPersons, mhaWithoutPersonsRefDepth, uploadAvailable  } = this.state;

    return (
      <React.Fragment>
        {getHeader(this.saveData)}
        {getNavBar(this.handleMoveToNextStep, this.handleMoveToArbitraryStep)}
        <section className='scene_section _border_top_1 floatation-test-date-section'>
          <header>Flotation Test Date</header>
          <p className='reminder'>
            If Flotation Test Date is selected, upload the Test Report
            <br />
            {'If Boat <20 Ft - application step Flotation is required'}
          </p>
          <DatePicker error={this.errors.testDate} selectedDate={testDate} handleSelectDate={this.handleDateChoose} />
        </section>

        <section className='scene_section _border_top_1 floatation-test-upload-section'>
          <header>Upload Test Report</header>

          {showControlFields === undefined && (
          <Button
          label='Upload Test Report'
          buttonClassName='_height_30 _font_size_14'
          fontSize={14}
          onClick={() => this.handleUploadReq() }
          />
          )}

          {showControlFields !== undefined && (
          <p className='reminder'>
            Please provide the Max Heel Angle for the specified tests and indicate the reference depth they were taken from.
          </p>
          )}

          {showControlFields !== undefined && (
            <p className="group-label">Max Heel Angles: </p>)}
            {showControlFields !== undefined && (
              <div className='multi-input-fields-wrapper _margin_right_10'>
                <MultiInput
                        label='Angle Persons Capacity * '
                        value={mhaPersonsCapacity || ''}
                        onChange={this.handleInputChange('mhaPersonsCapacity')}
                        styles={{ height: 40 }}
                        error={this.inputErrors['mhaPersonsCapacity']}
                        units='°'
                        isNumeric
                        allowNegative
                      />
                <MultiInput
                        label=' Ref. Depth *'
                        value={mhaPersonsCapacityRefDepth || ''}
                        onChange={this.handleInputChange('mhaPersonsCapacityRefDepth')}
                        styles={{ height: 40 }}
                        error={this.inputErrors['mhaPersonsCapacityRefDepth']}
                        units='in.'
                        isNumeric
                        allowNegative
                      />
              </div>
            )}
            {showControlFields !== undefined && (
            <div className='multi-input-fields-wrapper _margin_right_10'>
                <MultiInput
                        label='Angle Starboard Stability * '
                        value={mhaStarboardStability || ''}
                        onChange={this.handleInputChange('mhaStarboardStability')}
                        styles={{ height: 40 }}
                        error={this.inputErrors['mhaStarboardStability']}
                        units='°'
                        isNumeric
                        allowNegative
                      />
                <MultiInput
                        label=' Ref. Depth *'
                        value={mhaStarboardStabilityRefDepth || ''}
                        onChange={this.handleInputChange('mhaStarboardStabilityRefDepth')}
                        styles={{ height: 40 }}
                        error={this.inputErrors['mhaStarboardStabilityRefDepth']}
                        units='in.'
                        isNumeric
                        allowNegative
                      />
            </div>
            )}
            {showControlFields !== undefined && (
            <div className='multi-input-fields-wrapper _margin_right_10'>
                <MultiInput
                        label='Angle Port Stability * '
                        value={mhaPortStability || ''}
                        onChange={this.handleInputChange('mhaPortStability')}
                        styles={{ height: 40 }}
                        error={this.inputErrors['mhaPortStability']}
                        units='°'
                        isNumeric
                        allowNegative
                      />
                <MultiInput
                        label=' Ref. Depth *'
                        value={mhaPortStabilityRefDepth || ''}
                        onChange={this.handleInputChange('mhaPortStabilityRefDepth')}
                        styles={{ height: 40 }}
                        error={this.inputErrors['mhaPortStabilityRefDepth']}
                        units='in.'
                        isNumeric
                        allowNegative
                      />
            </div>
            )}
            {showControlFields !== undefined && (
            <div className='multi-input-fields-wrapper _margin_right_10'>
                <MultiInput
                        label='Angle Without Persons * '
                        value={mhaWithoutPersons || ''}
                        onChange={this.handleInputChange('mhaWithoutPersons')}
                        styles={{ height: 40 }}
                        error={this.inputErrors['mhaWithoutPersons']}
                        units='°'
                        isNumeric
                        allowNegative
                      />
                <MultiInput
                        label=' Ref. Depth *'
                        value={mhaWithoutPersonsRefDepth || ''}
                        onChange={this.handleInputChange('mhaWithoutPersonsRefDepth')}
                        styles={{ height: 40 }}
                        error={this.inputErrors['mhaWithoutPersonsRefDepth']}
                        units='in.'
                        isNumeric
                        allowNegative
                      />
            </div>
            )}

        </section>
        <section className='scene_section'>
          <FilePicker
            mainWrapperClassName='_box-sizing_border-box'
            handleFileSelect={this.handleFileSelect}
            handleRemoveFile={this.handleRemoveFile}
            isEditable={uploadAvailable}

            notEditableStateSectionHeader='Flotation Test Reports'
            files={files}
            httpParams={{ currentMethod: boatAPI.downloadReport, currentId: boat.id }}
            error={this.errors.files}
          />
        </section>
        <ApplicationActions
          backButtonLabel='Prev. Step'
          saveButtonLabel='Next Step'
          saveButtonAction={
            stepIsChanged
              ? this.handleMoveToNextStep
              : () => {
                this.handleMoveToArbitraryStep('next');
              }
          }
          backButtonAction={this.handleMoveToArbitraryStep}
        />
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/Scenes/BoatManufacturer/Application/New/FloatationCapacity.jsx